import { useRouteMatch } from 'react-router';

export const ServiceOrderRoutes = () => {
  const { url } = useRouteMatch();

  return <></>;
};
